const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAmerican(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 504 504",
    style: {
      enableBackground: "new 0 0 504 504"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff"
    },
    d: "M453.79 432h-360V72h360v360z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M450 450v-62.75h-47.78l-24.59-27.2-24.72 27.2H195.39V260.5h-50.84l63.06-142.71h60.82l21.71 48.89v-48.89h75.28l13.07 36.84 13.15-36.84H450V54H54v396h396zm-39.73-78.62H450l-52.55-55.73L450 260.56h-39.1l-32.45 35.46-32.14-35.46h-39.74l52.24 55.41-52.24 55.41h38.63l32.61-35.78 32.46 35.78zm9.3-55.68L450 348.08V283.6l-30.43 32.1zm-177.11 30.03v-17.26h62.53v-25.01h-62.53v-17.25h64.12v-25.65h-94.36v110.82h94.36v-25.65h-64.12zm177.62-101.25H450V133.65h-46.55l-24.86 69.03-24.7-69.03h-47.34v110.82h29.92V166.9l28.5 77.58h26.6l28.5-77.74v77.74h.01zm-147.56 0h34.04l-48.92-110.82H218.7l-48.92 110.82h33.25l9.18-22.16h50.98l9.33 22.16zm-19.78-47.02h-30.08l15.04-36.25 15.04 36.25z",
    style: {
      fill: "#0079c1"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAmerican);
export default __webpack_public_path__ + "static/media/american.29f7c30356825d951b21a14ebb8b23c1.svg";
export { ForwardRef as ReactComponent };